import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { forwardRef, useContext } from "react";
import { Box } from "../Box/Box.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { TableContext, TableBodyContext } from "./TableContext.mjs";
import { tableSection } from "./Table.css.mjs";
const TableBody = forwardRef(
  ({ children, data, ...restProps }, ref) => {
    const tableContext = useContext(TableContext);
    assert(tableContext, "TableBody must be used within a Table component");
    return /* @__PURE__ */ jsx(TableBodyContext.Provider, { value: true, children: /* @__PURE__ */ jsx(
      Box,
      {
        component: "tbody",
        className: tableSection,
        ref,
        ...buildDataAttributes({ data, validateRestProps: restProps }),
        children
      }
    ) });
  }
);
export {
  TableBody
};
